import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
/**
 * Display plain error
 * @param props
 * @returns
 */
export function ErrorView(props) {
    return (_jsxs(Alert, { severity: "error", children: [_jsx(AlertTitle, { children: props.error.message }), props.error.stack ? (_jsx(Tooltip, { title: _jsx("code", { children: props.error.stack }), children: _jsx(Button, { color: "error", children: "Stack" }) })) : null] }));
}
//# sourceMappingURL=ErrorView.js.map